// SPDX-License-Identifier: GPL-3.0-or-later
//
// Tiny hash router. Routes are functions from a parsed hash to a render call.

export type RouteName = 'dashboard' | 'onboarding' | 'settings' | 'privacy' | 'smoke' | 'handoff' | 'job';

export interface Route {
  name: RouteName;
  params: Record<string, string>;
}

export function parseHash(hash: string): Route {
  const trimmed = hash.replace(/^#\/?/, '');
  const [path = '', queryString = ''] = trimmed.split('?');
  const params = Object.fromEntries(new URLSearchParams(queryString));

  switch (path) {
    case '':
      return { name: 'dashboard', params };
    case 'onboarding':
      return { name: 'onboarding', params };
    case 'settings':
      return { name: 'settings', params };
    case 'privacy':
      return { name: 'privacy', params };
    case 'smoke':
      return { name: 'smoke', params };
    case 'handoff':
      return { name: 'handoff', params };
    case 'job':
      return { name: 'job', params };
    default:
      return { name: 'dashboard', params };
  }
}

export function navigate(name: RouteName, params: Record<string, string> = {}): void {
  const query = new URLSearchParams(params).toString();
  const path = name === 'dashboard' ? '' : name;
  const next = query ? `#/${path}?${query}` : `#/${path}`;
  if (location.hash !== next) location.hash = next;
}

export function onRouteChange(handler: (r: Route) => void): () => void {
  const fire = (): void => handler(parseHash(location.hash));
  window.addEventListener('hashchange', fire);
  return () => window.removeEventListener('hashchange', fire);
}
